import translations from "../translations/_translations";
import { MODE } from '../utils/consts';

const getMessage = (key, item) => {
	// const locale = navigator.language.includes('es') ? 'es' : 'en';
	const locale = 'es';
	const isTranslateExist = translations[locale][key];
	const translation = isTranslateExist ?? '';

	if (MODE === 'dev') {
		if (!translations['en'][key]) {
			console.warn(`No 'en' locale translate for ${item.outerHTML}`);
		}
		if (!translations['es'][key]) {
			console.warn(`No 'es' locale translate for ${item.outerHTML}`);
		}
	}

	return translation;
};

export default getMessage;
